import { ToastProvider } from 'dreambel-ui';
import { Header } from './components/header/Header';
import { Footer } from './components/footer';
import { Hero } from './sections/Hero';
import { Features } from './sections/Features/Features';
import { Pricing } from './sections/Pricing/Pricing';
import { Faq } from './sections/FAQ';
import { Closing } from './sections/Closing';
import { SEOHead, BaseSEOTags } from './components/SEOHead';

function App() {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
}

function AppContent() {
  return (
    <div className="min-h-screen max-w-[100vw] bg-md-background text-md-on-background">
      <SEOHead page="home" />
      <BaseSEOTags />
      <Header />
      <main className="main-container">
        <div className="content container mx-auto p-4">
          <Hero />
          <Features />
          <Pricing />
          <Faq />
          <Closing />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
